import { _ as a } from "./index817.mjs";
var t = a;
function s() {
  this.__data__ = new t(), this.size = 0;
}
var e = s;
export {
  e as _
};
